import styled from 'styled-components';

import { COLORS } from 'constants/colors';

const HeaderSubtitle = styled.span`
  color: ${COLORS.SUB_TEXT};
`;

export default HeaderSubtitle;
